import React, { useState } from 'react'
import TableEquipments from '../../components/utils/tableEquipments'
import '../../pages/GO/go.css'
import TableBookingEquipments from './tableBookingEquipments'
import TableShipmentCharges from './tableShipmentCharges'
import { useMediaQuery } from '@mui/material'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import GroupIcon from '@mui/icons-material/Group'
import { AirlineStopsOutlined, Anchor, RequestQuoteOutlined } from '@mui/icons-material';
import { M_CheckBox, M_InputTextField, M_Button, M_TimeLine, M_MessageBoard, M_Fieldset, M_Header } from 'src/M_Components'

export default function SimpleViewBooking({
    valueTimeline, setDefaultBooking, voyage, voyageDict, entities, entitiesDict,
    portsLocations, locationsDict, shipmentObjArray, setShipmentObjArray, bookingEquipmentArray, shipmentChargesArray = [],
    t, openDrawer,
    setOpenDrawer, selectedLine, setSelectedLine, changedList, drawerName, setDrawerName,
    extraValues, operation, deleteBooking, leavingPage, setLeavingPage, functionLeavingPage,
    ctx, fieldsInDrawerEquipment, fieldsInDrawerShipment, listErrors,
    isAdmin = false, adminDict = new Map() }) {

    const [open, setOpen] = useState(false)
    const [OpenModalSeeErrors, setOpenModalSeeErrors] = useState(false)
    const matches = useMediaQuery('(min-width:1600px)')

    return (
        <div style={{}}>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        {listErrors.ErrorMessage ? (
                            <M_Button
                                tooltip={t("SeeErrors")}
                                label={t("SeeErrors")}
                                icon={<i className="pi pi-info iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                onClick={() => setOpenModalSeeErrors(true)}
                            />
                        ) : null}
                        {operation === 'Delete' && <M_Button
                            tooltip={t("ApproveDeletion")}
                            label={t("ApproveDeletion")}
                            icon={<img src='/icons/svgsDaNet/trash-2.svg' style={{ width: '20px', filter: 'invert(12%) sepia(97%) saturate(4989%) hue-rotate(358deg) brightness(83%) contrast(114%)' }} alt='ChangeView' />}
                            onClick={() => { setOpen(true) }}
                        />}
                    </>
                }
            />
            <div className='principalDivTimeline'>
                <div className='divTimeline'>
                    <M_TimeLine valueTimeline={valueTimeline} color={'var(--color-blue)'} />
                </div>
            </div>
            <div className='divBaseBooking'>
                <div className='divButtonSubmitBooking'>
                    <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ margin: '0' }}>Booking Number: &nbsp; </h4> <h2 style={{ margin: '0' }}>{extraValues.get('BookingNumber')}</h2>
                    </div>
                    {extraValues.get('QuoteName') && 
                        <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                            <h4 style={{ margin: '0' }}>Quote Name: &nbsp; </h4><h2 style={{ margin: '0' }}> {extraValues.get('QuoteName')}</h2>
                        </div>
                    }
                    {/* {operation === 'Delete' &&
                        <M_Button
                            tooltip={t("ApproveDeletion")}
                            hoverEffect
                            normal
                            bold
                            borderColor={'var(--color-grey)'}
                            label={t("ApproveDeletion")}
                            icon={<img src='/icons/svgsDaNet/trash-2.svg' style={{ filter: 'invert(12%) sepia(97%) saturate(4989%) hue-rotate(358deg) brightness(83%) contrast(114%)' }} alt='ChangeView' className='iconCreateBooking' />}
                            onClick={() => setOpen(true)}
                        />
                    } */}
                </div>
                <div className='menusBooking'>
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center' }}><DirectionsBoatIcon style={{ marginRight: '5px' }} /> {t("Voyage")}</span>}
                        elements={
                            <div className='divTextfieldVoyage'>
                                {voyage.map((key, index) => (
                                    <div className='textfield' key={index}>
                                        <M_InputTextField
                                            label={key.label}
                                            disabled
                                            value={voyageDict.get(key.label) || ''}
                                            secondColor={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                            color={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                        />
                                    </div>
                                ))}

                                {isAdmin && adminDict.get('TradeBound') && (
                                    <div className='textfield'>
                                        <M_InputTextField label={t('Bound')} disabled value={adminDict.get('TradeBound') || ''} />
                                    </div>
                                )}
                                {!matches && <div style={{ height: '62px' }}></div>}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center', }}><GroupIcon style={{ marginRight: '5px' }} /> {t("Entities")}</span>}
                        elements={
                            <div className='divTextfield'>
                                {entities.map((key, index) => (
                                    key.code === 'ClientCode' || key.code === 'ClientVAT' ?
                                        <div className='textfield' key={index}>
                                            <M_InputTextField
                                                label={key.label}
                                                disabled
                                                value={entitiesDict.get(key.label) || ''}
                                                secondColor={changedList.includes('ClientId') ? 'var(--color-yellow)' : null}
                                                color={changedList.includes('ClientId') ? 'var(--color-yellow)' : null}
                                            />
                                        </div>
                                        :
                                        key.code === 'InvoiceCode' || key.code === 'InvoiceVat' ?
                                            <div className='textfield' key={index}>
                                                <M_InputTextField
                                                    label={key.label}
                                                    disabled
                                                    value={entitiesDict.get(key.label) || ''}
                                                    secondColor={changedList.includes('InvoiceId') ? 'var(--color-yellow)' : null}
                                                    color={changedList.includes('InvoiceId') ? 'var(--color-yellow)' : null}
                                                />
                                            </div>
                                            :
                                            <div className='textfield' key={index}>
                                                <M_InputTextField
                                                    label={key.label}
                                                    disabled
                                                    value={entitiesDict.get(key.label) || ''}
                                                    secondColor={changedList.includes(key.code) ? 'var(--color-yellow)' : null}
                                                    color={changedList.includes(key.code) ? 'var(--color-yellow)' : null}
                                                />
                                            </div>
                                ))}
                                {isAdmin && <>
                                    {adminDict.get('SubAccountCode') && <div className='textfield'><M_InputTextField label={t('SubAccount')} disabled value={adminDict.get('SubAccountCode') || ''} /></div>}
                                    {adminDict.get('ShipperCode') && <div className='textfield'><M_InputTextField label={t('Shipper')} disabled value={adminDict.get('ShipperCode') || ''} /></div>}
                                    {adminDict.get('ConsigneeCode') && <div className='textfield'><M_InputTextField label={t('Consignee')} disabled value={adminDict.get('ConsigneeCode') || ''} /></div>}
                                    {adminDict.get('NotifyCode') && <div className='textfield'><M_InputTextField label={t('Notify')} disabled value={adminDict.get('NotifyCode') || ''} /></div>}
                                    {adminDict.get('AgentCode') && <div className='textfield'><M_InputTextField label={t('Agent')} disabled value={adminDict.get('AgentCode') || ''} /></div>}
                                    {adminDict.get('ExternalLineCode') && <div className='textfield'><M_InputTextField label={t('ExtLineCode')} disabled value={adminDict.get('ExternalLineCode') || ''} /></div>}
                                </>}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center', }}><Anchor style={{ marginRight: '5px' }} /> {t("Ports")}</span>}
                        elements={
                            <div className='divTextfield'>
                                {isAdmin && adminDict.get('PreCarriageName') && <div className='textfield'><M_InputTextField label={t('PreCarriage')} disabled value={adminDict.get('PreCarriageName') || ''} /></div>}
                                {portsLocations.map((value, index) => (
                                    value.type === "textfield" ?
                                        <div key={index} className='textfield'>
                                            <M_InputTextField
                                                label={value.label}
                                                disabled
                                                value={locationsDict.get(value.label) || ''}
                                                secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                            />
                                        </div>
                                        : value.type === "checkbox" ?
                                            <div className='checkbox textfield paddingLeft' key={index}>
                                                {value.label === "Transhipment" ?
                                                    <M_CheckBox
                                                        label={value.label}
                                                        disabled
                                                        checked={locationsDict.get("Original Port") !== null ? true : false}
                                                        // secondColor={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                        color={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                    /> : <M_CheckBox />
                                                }
                                                {/* <p style={changedList.includes(value.code) ? { color: 'var(--color-yellow)' } : {}} className='textCheckbox'>{value.label}</p> */}
                                            </div>
                                            :
                                            ""
                                ))}
                                {isAdmin && adminDict.get('OnCarriageName') && <div className='textfield'><M_InputTextField label={t('OnCarriage')} disabled value={adminDict.get('OnCarriageName') || ''} /></div>}
                            </div>
                        }
                    />
                </div >
            </div >
            {isAdmin && (
                <div className='divBaseBooking' style={{ marginTop: '10px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                        <M_Fieldset
                            labelInside
                            label={<span style={{ display: 'flex', alignItems: 'center' }}><AirlineStopsOutlined style={{ marginRight: '5px' }} /> {t("SecondProcess")}</span>}
                            elements={
                                <div className='divTextfield'>
                                    <div className='textfield'><M_InputTextField label={t('SVoyage')} disabled value={`${adminDict.get('SecondVesselCode') || ''} ${adminDict.get('SecondVoyageNumber') || ''}`.trim()} /></div>
                                    <div className='textfield'><M_InputTextField label={t('SVesselCode')} disabled value={adminDict.get('SecondVesselCode') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('SLineCode')} disabled value={adminDict.get('SecondTradeLineCode') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('SServiceCode')} disabled value={adminDict.get('SecondTradeCode') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('TradeName')} disabled value={adminDict.get('SecondTradeName') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('SBound')} disabled value={adminDict.get('SecondTradeBound') || ''} /></div>
                                </div>
                            }
                        />
                        <M_Fieldset
                            labelInside
                            label={<span style={{ display: 'flex', alignItems: 'center' }}><RequestQuoteOutlined style={{ marginRight: '5px' }} /> {t("ProcessDetails")}</span>}
                            elements={
                                <div className='divTextfield'>
                                    <div className='textfield'><M_InputTextField label={t('BLNumber')} disabled value={adminDict.get('BLNumber') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('ShippingCode')} disabled value={adminDict.get('ShippingConditionCode') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('MRN')} disabled value={adminDict.get('Mrn') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('Currency')} disabled value={adminDict.get('CurrencyCode') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('NrDocs')} disabled value={adminDict.get('DocumentQuantity') ?? ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('Incoterms')} disabled value={adminDict.get('IncotermsCode') || ''} /></div>
                                    <div className='textfield'><M_InputTextField label={t('CStatusCode')} disabled value={adminDict.get('CustomStatusCode') || ''} /></div>
                                </div>
                            }
                        />
                    </div>
                </div>
            )}
            <M_Fieldset
                labelInside
                label={<span style={{ display: 'flex', alignItems: 'center', }}><AirlineStopsOutlined style={{ marginRight: '5px' }} /> {t("Shipments")}</span>}
                elements={
                    <div className='divForm'>
                        <TableEquipments
                            value={shipmentObjArray}
                            setValue={setShipmentObjArray}
                            isView={true}
                            selectedLine={selectedLine}
                            setSelectedLine={setSelectedLine}
                            openDrawer={openDrawer}
                            setOpenDrawer={setOpenDrawer}
                            drawerName={drawerName}
                            setDrawerName={setDrawerName}
                            fieldsInDrawerShipment={fieldsInDrawerShipment}
                            fieldsInDrawerEquipment={fieldsInDrawerEquipment}
                        />
                    </div>
                }
            />
            {bookingEquipmentArray.length > 0 && (
            <M_Fieldset
                labelInside
                label={<span style={{ display: 'flex', alignItems: 'center', }}><i className="pi pi-box" style={{ marginRight: '10px' }}></i>  {t("Equipments")}</span>}
                elements={
                    <div className='divForm'>
                        <TableBookingEquipments
                            value={bookingEquipmentArray}
                            setValue={() => {}} 
                            isView={true}
                            openDrawer={openDrawer}
                            setOpenDrawer={setOpenDrawer}
                            selectedLine={selectedLine}
                            setSelectedLine={setSelectedLine}
                            drawerName={drawerName}
                            setDrawerName={setDrawerName}
                        />
                    </div>
                }
            />
            )}
            {isAdmin && shipmentChargesArray.length > 0 && (
            <M_Fieldset
                labelInside
                label={<span style={{ display: 'flex', alignItems: 'center' }}><RequestQuoteOutlined style={{ marginRight: '10px' }} /> {t("ShipmentCharges")}</span>}
                elements={
                    <div className='divForm'>
                        <TableShipmentCharges value={shipmentChargesArray} isView />
                    </div>
                }
            />
            )}
            {/* <div className='divTitleEquipments stickyBaseBase'>
                {t("Equipments")}
            </div> */}
            <M_MessageBoard
                title={t('ApproveDeletion')}
                open={open}
                onClose={() => { setOpen(false) }}
                body={t('BodyConfirmDelete')}
                footer={
                    <M_Button
                        normal
                        hoverEffect
                        label={t('ButtonConfirm')}
                        backgroundColor={'var(--color-green)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => {
                            setOpen(false)
                            deleteBooking()
                        }}
                    />
                }
            />

            {/* MODAL SE ERRORS */}
            <M_MessageBoard
                open={OpenModalSeeErrors}
                minWidth={'30%'}
                onClose={() => setOpenModalSeeErrors(false)}
                title={t("ListErrors")}
                body={
                    <span>
                       <b>{listErrors.CreatedOn}</b>: {listErrors.ErrorMessage}
                    </span>
                }
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setOpenModalSeeErrors(false)} label={t("ButtonCancel")} />
                    </span>
                }
            />

            <M_MessageBoard
                warning
                open={leavingPage}
                onClose={functionLeavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBodyRead")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div>
    )
}